export const setOverviewDisciplineFilter = (value) => (dispatch) => {
    dispatch({
        type: 'SET_OVERVIEW_DISCIPLINE_FILTER',
        value
    });
};

export const setOverviewDateFilter = (filter) => (dispatch) => {
    dispatch({
        type: 'SET_OVERVIEW_DATE_FILTER',
        data: filter
    });
};

export const setOverviewFilter = (filter) => (dispatch) => {
    dispatch({
        type: 'SET_OVERVIEW_FILTER',
        data: filter
    });
};

export const setOverviewTextFilter = (row, value) => (dispatch) => {
    dispatch({
        type: 'SET_OVERVIEW_TEXT_FILTER',
        row,
        value
    });
};

export const resetOverviewFilters = () => (dispatch) => {
    dispatch({
        type: 'RESET_OVERVIEW_FILTER'
    });
};

